import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";
import { useAuthStore } from "../store/useAuthStore";
import {
  Box,
  Button,
  Modal,
  Pagination,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import Loader from "../Components/loader/Loader";

export default function Users() {
  const { getUserAllFunctionApi, users, deleteUser, dowloadUser } =
    useAuthStore();
  const [loadingStyle, setLoadingStyle] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [field, setField] = useState("username");
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteID] = useState(null);

  const handleChangePagination = (event, value) => {
    setPageNumber(value);
  };

  const handleCancelDelete = () => {
    setOpen(false);
  };

  const handleDelete = (id) => {
    setDeleteID(id);
    setOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      // setOpen(false)
      // setLoading(true)
      const res = await deleteUser(deleteId);
      setOpen(false);
      // if (res) {
      //     setTable(table.filter((item) => item._id !== itemId))
      // }
      // setLoading(false)
    } catch (error) {
      console.log(error);
    }
  };

  const handleDowload = async () => {
    setLoadingStyle(true);
    await dowloadUser(pageNumber, pageSize, search, field);
    setLoadingStyle(false);
  };

  useEffect(() => {
    const getAllUserApi = async () => {
      setLoading(true);
      const data = await getUserAllFunctionApi(
        pageNumber,
        pageSize,
        search,
        field
      );
      if (data) {
        setTotalPages(data?.totalPages);
      }
      // console.log(search,field,"nameLorem")
      setLoading(false);
    };
    getAllUserApi();
  }, [pageNumber, search, field]);
  return (
    <div id="dashboard-root" className="flex min-h-[1000px] w-full">
      <Loader loading={loadingStyle} />
      {/* <!-- Sidebar --> */}
      <Sidebar />
      {/* <!-- Main Content --> */}
      <main id="main-content" className="flex-1 px-10 py-8">
        {/* <!-- Header --> */}
        <Header title="Users" />
        <div id="users-page" className="mb-6">
          <div className="flex justify-between items-center mb-6">
            <div>
              {/* <h1 class="text-2xl font-bold text-gray-800">Users</h1> */}
              <p className="text-gray-600">Manage user accounts and permissions</p>
            </div>
            <div className="flex space-x-3">
              <button className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center">
                <i className="fa-solid fa-filter mr-2"></i>
                Filter
              </button>
              <button
                className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center"
                onClick={() => handleDowload()}
              >
                <i className="fa-solid fa-download mr-2"></i>
                Export
              </button>
              <Link
                to="/user/add-user"
                id="add-user-btn"
                class="bg-primary-600 hover:bg-primary-700 text-white rounded-lg px-4 py-2 text-sm font-medium flex items-center"
              >
                <i className="fa-solid fa-plus mr-2"></i>
                Add User
              </Link>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="p-4 border-b flex items-center justify-between">
              {/* <div class="flex items-center">
                                <input type="checkbox" class="rounded text-primary-600 mr-3" />
                                <span class="text-sm text-gray-600">Select All</span>
                            </div> */}
              <div className="relative">
                <input
                  value={search}
                  onChange={(ele) => setSearch(ele.target.value)}
                  type="text"
                  placeholder="Search usersName..."
                  className="border rounded-lg px-3 py-2 text-sm w-64"
                />
                <i
                  className="fa-solid fa-search absolute right-3 text-gray-400"
                  style={{ top: "0.375rem" }}
                ></i>
              </div>
            </div>
            <div className="overflow-x-auto">
              {(
                <table className="w-full">
                  <thead className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <tr>
                      {/* <th class="p-4 w-10"></th> */}
                      <th className="p-4">User</th>
                      <th className="p-4">Role</th>
                      <th className="p-4">Email</th>
                      <th className="p-4">Department</th>
                      <th className="p-4">Last Login</th>
                      <th className="p-4">Full name</th>
                      <th className="p-4">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {loading
                      ? Array.from({ length: 5 }).map((_, rowIndex) => (
                          <TableRow key={rowIndex}>
                            {Array.from({ length: 8 }).map((_, colIndex) => (
                              <TableCell key={colIndex}>
                                <Skeleton variant="text" animation="wave" />
                              </TableCell>
                            ))}
                          </TableRow>
                        ))
                      : (users || []).map((ele, i) => (
                          <tr key={ele._id || i} className="hover:bg-gray-50">
                            {/* <td className="p-4">
                                                        <input type="checkbox" className="rounded text-primary-600" />
                                                    </td> */}
                            <td className="p-4">
                              <div className="flex items-center">
                                <img
                                  src={
                                    ele?.avatar ||
                                    "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg"
                                  }
                                  alt={ele?.fullName || "User"}
                                  className="w-8 h-8 rounded-full mr-3"
                                />
                                <div>
                                  <div className="font-medium text-gray-800">
                                    {ele?.fullName}
                                  </div>
                                  <div className="text-xs text-gray-500">
                                    ID: {ele?.userId || ele?._id}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="p-4 text-gray-600">
                              {ele?.role || "N/A"}
                            </td>
                            <td className="p-4 text-gray-600">{ele?.email}</td>
                            <td className="p-4 text-gray-600">
                              {ele?.department || "—"}
                            </td>
                            <td className="p-4 text-gray-600">
                              {ele?.lastLogin
                                ? new Date(ele?.lastLogin).toLocaleString(
                                    "en-IN",
                                    {
                                      dateStyle: "medium",
                                      timeStyle: "short",
                                    }
                                  )
                                : "Never"}
                            </td>
                            <td className="p-4 text-gray-600">
                              {ele?.fullName}
                            </td>
                            <td className="p-4">
                              <div className="flex space-x-2">
                                {/* <Link
                                                                to={`/user/edit-user/${ele?._id}`}
                                                                className="text-gray-500 hover:text-primary-600"
                                                            >
                                                                <i className="fa-solid fa-pencil"></i>
                                                            </Link> */}
                                <button
                                  className="text-gray-500 hover:text-red-600"
                                  onClick={() => handleDelete(ele?._id)}
                                >
                                  <i className="fa-solid fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              ) || <Skeleton count={10} />}
            </div>
            <Modal
              open={open}
              onClose={handleCancelDelete}
              aria-labelledby="confirm-delete-modal"
              aria-describedby="modal-to-confirm-deletion"
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "5px",
                  boxShadow: 24,
                  width: { xs: "80%", md: "500px" },
                  textAlign: "center",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Are you sure you want to delete this user?
                </Typography>
                <Button
                  variant="outlined"
                  color="#274156"
                  onClick={handleConfirmDelete}
                >
                  Yes
                </Button>
                <Button
                  variant="outlined"
                  color="#274156"
                  onClick={handleCancelDelete}
                  sx={{ marginLeft: "10px" }}
                >
                  No
                </Button>
              </Box>
            </Modal>
            <Stack spacing={2} className="flex items-center mb-6 mt-4 ">
              <Pagination
                count={totalPages}
                onChange={handleChangePagination}
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          </div>
        </div>
      </main>
    </div>
  );
}
